import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import widgetPreviewImage from './images/feedback-grid-preview.png'

const getWidgetScript = (companyKey) => `<div id="simplesat-full-width-widget"></div>
<script>
  (function(document) {
    var addWidgetScriptTag = function() {
      var lastScript = Array.prototype.slice.call(document.getElementsByTagName('script')).slice(-1)[0];
      var script = document.createElement('script');
      script.src = 'https://cdn.simplesat.io/js/widget/fullWidth.js';
      lastScript.parentNode.insertBefore(script, lastScript.nextSibling);
      script.addEventListener('load', function() {
        Widget.config({
          companyKey: '${companyKey}',
          primaryColor: '#57DD84',
          showTestimonialDate: true,
          maxFeedback: 6
        });
        Widget.render();
      });
    };
    document.addEventListener('DOMContentLoaded', addWidgetScriptTag);
  })(document);
</script>`

const onClickArea = (e) => {
  e.target.select()
}

export const FeedbackGrid = ({ companyKey }) => {
  const scriptText = getWidgetScript(companyKey)
  return (
    <React.Fragment>
      <h3>Feedback Grid</h3>
      <p>
        The feedback grid spans the full width of a web page, making it a great option to
        prominently showcase your positive feedback to website visitors. By default the grid
        displays two three column rows. All columns eventually stack on smaller resolutions and
        mobile devices.
      </p>
      <p>
        <a
          href="https://help.simplesat.io/en/articles/843342-publishing-customer-feedback-and-ratings#create-a-feedback-widget"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Using the feedback grid testimonial widget
        </a>
      </p>
      <h4>Example Screenshot</h4>
      <img
        className="ui fluid bordered image"
        src={widgetPreviewImage}
        alt="feedback widget preview"
      />
      <h3>Code</h3>
      <p>Place this code wherever you want the plugin to appear on your page.</p>
      <div className="ui form">
        <div className="field">
          <textarea readOnly rows="20" onClick={onClickArea} value={scriptText} />
        </div>
      </div>
      <h3>Settings</h3>
      <p>You can customize your widget's appearance by modifying the settings listed below.</p>

      <table className="ui celled striped table">
        <thead>
          <tr>
            <th>Setting</th>
            <th>Description</th>
            <th>Default</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>primaryColor</code>
            </td>
            <td>The color used for the quote icon and customer name.</td>
            <td>
              <code>#57DD84</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>showTestimonialDate</code>
            </td>
            <td>
              Option to display the date feedback was given. Set <code>true</code> to display,{' '}
              <code>false</code> to hide.
            </td>
            <td>
              <code>true</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>maxFeedback</code>
            </td>
            <td>Choose the maximum number of feedback comments to display.</td>
            <td>
              <code>6</code>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Installation Instructions</h3>
      <h4>1. Add code to your website</h4>
      <p>
        Copy the entire snippet of code above and paste it where you would like it to display on
        your website. The widget is responsive, which means it'll span the entire width of any
        container it's placed in.
      </p>
      <div className="ui message">
        <p>
          Some content management systems might not allow you include JavaScript directly through
          the content editor window. To get around this, you can add the <code>&lt;script&gt;</code>{' '}
          portion of the code in the footer of your website. Then, add{' '}
          <code>&lt;div id="simplesat-full-width-widget"&gt;&lt;/div&gt;</code> to any page you'd
          like the widget to display.
        </p>
      </div>

      <h4>2. Publish and test</h4>

      <p>
        On the
        <Link to="/feedback"> Feedback page</Link>, publish a testimonial by clicking the publish
        icon (<i className="far fa-bullhorn icon" />) next to any comment. After you publish, refresh
        the page where you've installed the feedback widget to ensure new testimonials are being
        updated properly.
      </p>
    </React.Fragment>
  )
}

FeedbackGrid.propTypes = {
  companyKey: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/TestimonialsLegacy/FeedbackGrid.js